import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';

import { applicationsUpdateActions } from '../actions';
import { Application } from '../models';
import { ApplicationsUpdateState } from '../reducers/applications-update.reducer';
import {
  selectApplicationsUpdateData,
  selectApplicationsUpdateError,
  selectApplicationsUpdateLoading,
} from '../selectors';

@Injectable()
export class ApplicationsUpdateFacade {
  private readonly store: Store<ApplicationsUpdateState> = inject(Store);

  public update(application: Application, surveyData?: Record<string, unknown>): void {
    this.store.dispatch(
      applicationsUpdateActions.update({
        application,
        surveyData,
      }),
    );
  }

  public selectData(): Signal<Application> {
    return this.store.selectSignal(selectApplicationsUpdateData);
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectApplicationsUpdateLoading);
  }

  public selectError(): Signal<boolean> {
    return this.store.selectSignal(selectApplicationsUpdateError);
  }

  public clearStore(): void {
    this.store.dispatch(applicationsUpdateActions.clearStore());
  }
}
